jQuery(document).ready(function ($) {
  var searchTimer;
  var minCharacters = 1;
  var currentPage = 1;
  var searchTerm = "";
  var isScrolling = false;

  // Add a loading overlay to the magazine-past__search-results container
  $(".magazine-past__search-results").append('<div id="loading-overlay"> <div>Loading Issues</div></div>');

  function scrollToTop() {
    if (!isScrolling) {
      isScrolling = true;
      $("html, body").animate({ scrollTop: "60px" }, "300", function () {
        isScrolling = false;
      });
    }
  }

  function getAllIssues(page = 1, scrollAfterLoad = false) {
    // Show loading overlay
    $("#loading-overlay").show();

    $.ajax({
      url: ajax_object.ajax_url,
      type: "POST",
      data: {
        action: "magazine_issues_ajax_search",
        search_term: searchTerm,
        security: ajax_object.nonce,
        page: page,
      },
      success: function (response) {
        if (response.success) {
          $(".magazine-past__search-results").html(response.data.html);
          // Re-append the loading overlay as it was removed when replacing the HTML
          $(".magazine-past__search-results").append($("#loading-overlay"));
          updatePagination(response.data.total_pages, response.data.current_page);

          // Wait for images to load
          var $images = $(".magazine-past__search-results img");
          var loadedImages = 0;

          if ($images.length === 0) {
            // If there are no images, hide overlay immediately
            $("#loading-overlay").hide();
            $(".magazine-issue__grid-wrapper").addClass("fade-in-up");
            if (scrollAfterLoad) scrollToTop();
          } else {
            $images
              .on("load", function () {
                loadedImages++;
                if (loadedImages === $images.length) {
                  // All images have loaded
                  $("#loading-overlay").hide();
                  $(".magazine-issue__grid-wrapper").addClass("fade-in-up");
                  if (scrollAfterLoad) scrollToTop();
                }
              })
              .each(function () {
                // Trigger load event for cached images
                if (this.complete) $(this).trigger("load");
              });
          }
        } else {
          $(".magazine-past__search-results").html("<p>Error occurred. Please try again.</p>");
          $("#loading-overlay").hide();
          if (scrollAfterLoad) scrollToTop();
        }
      },
      error: function (xhr, status, error) {
        $(".magazine-past__search-results").html("<p>Error occurred. Please try again.</p>");
        $("#loading-overlay").hide();
        if (scrollAfterLoad) scrollToTop();
      },
    });
  }

  function updatePagination(totalPages, currentPage) {
    var paginationHtml = "";
    if (totalPages > 1) {
      paginationHtml += '<div class="pagination latest-news__pagination">';

      // Previous button
      if (currentPage > 1) {
        paginationHtml += '<a href="#" class="page-nav prev" data-page="' + (currentPage - 1) + '"><p class="pagination-text">Previous</p></a>';
      }

      // Calculate start and end pages
      var startPage = Math.max(1, currentPage - 1);
      var endPage = Math.min(totalPages, startPage + 2);

      // Adjust startPage if endPage is at the limit
      if (endPage === totalPages) {
        startPage = Math.max(1, endPage - 2);
      }

      // Add page numbers
      for (var i = startPage; i <= endPage; i++) {
        if (i === currentPage) {
          paginationHtml += '<span class="page-number current">' + i + "</span>";
        } else {
          paginationHtml += '<a href="#" class="page-number" data-page="' + i + '">' + i + "</a>";
        }
      }

      // Last page
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          var nextJumpPage = Math.min(totalPages, currentPage + 3);
          paginationHtml += '<a href="#" class="ellipsis" data-page="' + nextJumpPage + '">...</a>';
        }
        paginationHtml += '<a href="#" class="page-number" data-page="' + totalPages + '">' + totalPages + "</a>";
      }

      // Next button
      if (currentPage < totalPages) {
        paginationHtml += '<a href="#" class="page-nav next" data-page="' + (currentPage + 1) + '"> <p class="pagination-text">Next</p></a>';
      }

      paginationHtml += "</div>";

      // Add "Latest Issue" button if not on the first page
      if (currentPage > 2) {
        paginationHtml += '<div class="back-to-first"><a href="#" class="page-nav latest-issue" data-page="1"><p class="pagination-text">Latest Issues</p></a></div>';
      }
    }
    $(".magazine-past__pagination").html(paginationHtml);
  }

  $("#search-term").on("input", function () {
    searchTerm = $(this).val();
    currentPage = 1;

    clearTimeout(searchTimer);

    if (searchTerm.length === 0 || searchTerm.length >= minCharacters) {
      searchTimer = setTimeout(function () {
        getAllIssues(currentPage, false);
      }, 300);
    } else {
      $(".magazine-past__search-results").html("<p>Please enter at least " + minCharacters + " characters to search.</p>");
      $(".magazine-past__pagination").html("");
    }
  });

  $(document).on("click", ".page-number:not(.current), .page-nav, .ellipsis", function (e) {
    e.preventDefault();
    var newPage = parseInt($(this).data("page"));
    if (newPage !== currentPage) {
      currentPage = newPage;
      getAllIssues(currentPage, true);
    }
  });

  // Prevent form submission
  $("#ajax-search-form").on("submit", function (e) {
    e.preventDefault();
  });

  // Load all issues on page load without scrolling
  getAllIssues(1, false);
});
